var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ChatbotSandbox" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("chatbotv2.sandboxPage.title")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.sandboxPage.description")))]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "stories-loading" },
          _vm._l(3, function (skltn) {
            return _c(
              "div",
              { key: skltn, staticClass: "story story-skeleton" },
              [
                _c("a-skeleton", {
                  attrs: { active: true, paragraph: { rows: 3 } },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm.deletedStories.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("delete_outline"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.sandboxPage.emptyState")))]),
        ])
      : _c(
          "div",
          { staticClass: "stories" },
          _vm._l(_vm.deletedStories, function (story) {
            return _c(
              "div",
              { key: story.id, staticClass: "story story-deleted" },
              [
                _c(
                  "div",
                  { staticClass: "story-header" },
                  [
                    _c("div", { staticClass: "story-title" }, [
                      _vm._v(
                        _vm._s(
                          story.title ||
                            _vm.$t("chatbotv2.sandboxPage.unnamedScenario")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-popover",
                      {
                        staticClass: "story-menu-content",
                        attrs: { trigger: "click" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "story-menu-popover-items",
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreStory(story)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "undo" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbotv2.sandboxPage.restore")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr", {
                              staticStyle: {
                                "margin-bottom": "0.2rem",
                                "margin-top": "0.2rem",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "story-menu-popover-items",
                                on: {
                                  click: function ($event) {
                                    return _vm.permanentlyDeleteStory(story)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "delete" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "chatbotv2.sandboxPage.permanentlyDelete"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "story-menu-btn",
                            on: {
                              click: function (e) {
                                return e.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "story-content" }, [
                  story.description
                    ? _c("div", { staticClass: "story-description" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(story.description) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "story-meta" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatDeletedDate(story.deletedAt))),
                      ]),
                    ]),
                    _vm._v(" "),
                    story.deletedBy
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getDeletedByText(story.deletedBy))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("delete_outline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }